module.exports = __webpack_public_path__ + "img/ennion_morricone.da68f3ae.jpg";